/**
 * Serialize Objects
 * @returns {{}}
 */
$.fn.serializeObject = function() {
  let o = {};
  let a = this.serializeArray();
  $.each(a, function() {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
};

(function($) {
  $.fn.extend({
    /**
     * has not
     * @param param
     * @returns {*}
     */
    hasNot: function(param) {
      return this.not(this.has(param));
    },
  });
}(jQuery));

(function($) {
  /**
   * Shorten
   * @param settings
   * @returns {*}
   */
  $.fn.shorten = function(settings) {
    const config = {
      showChars: 90,
      ellipsesText: '...',
      moreText: LANG_STRINGS.mehrAnzeigen,
      lessText: LANG_STRINGS.wenigerAnzeigen,
    };

    if (settings) {
      $.extend(config, settings);
    }

    $(document).off('click', '.morelink');

    $(document).on({
      click: function() {
        const $this = $(this);
        if ($this.hasClass('less')) {
          $this.removeClass('less');
          $this.html(config.moreText);
        } else {
          $this.addClass('less');
          $this.html(config.lessText);
        }
        $this.parent().prev().toggle();
        $this.prev().toggle();
        return false;
      },
    }, '.morelink');

    return this.each(function() {
      const $this = $(this);
      if ($this.hasClass('shortened')) {
        return;
      }

      $this.addClass('shortened');
      const content = $this.html();
      if (content.length > config.showChars) {
        const c = content.substr(0, config.showChars);
        const h = content.substr(config.showChars, content.length - config.showChars);
        const html = c + '<span class="moreellipses">' + config.ellipsesText + ' </span><span class="morecontent"><span>' + h + '</span> <a href="#" class="morelink">' + config.moreText + '</a></span>';

        $this.html(html);
        $('.morecontent span').hide();
      }
    });
  };
})(jQuery);

/**
 * isDateSupported
 * @returns {boolean}
 */
window.isDateSupported = function() {
  const input = document.createElement('input');
  const value = 'a';
  input.setAttribute('type', 'date');
  input.setAttribute('value', value);
  return (input.value !== value);
};

/**
 * loadJs
 * @param url
 * @param location
 */
window.loadJs = function(url, location) {
  const scriptTag = document.createElement('script');
  scriptTag.src = url;

  location.appendChild(scriptTag);
};

/**
 * is IOS
 * @returns {boolean}
 */
window.isIOS = function() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

/**
 * isIOS
 */
window.iOSInputFix = function() {
  if (isIOS()) {
    var dateInputs = document.querySelectorAll('input[type="date"]');
    dateInputs.forEach(function(input) {
      input.classList.add('ios-date');
    });

    var timeInputs = document.querySelectorAll('input[type="time"]');
    timeInputs.forEach(function(input) {
      input.classList.add('ios-date');
    });
  }
};